import React from 'react';
import ReactDOM from 'react-dom';

import { App } from './blocks/App/App';

import './setLang';
import './lib/polyfills';

document.addEventListener('DOMContentLoaded', () => {
    // eslint-disable-next-line react/no-deprecated
    ReactDOM.render(<App />, document.querySelector('#app'));
});
